<template>
  <div class="nodeBox" :class="{ 'selectedBox': selected }">
    <div v-if="this.selected" id="toolbar">
      <BaseButton
        :text="'Add Tool'"
        :icon="ListPlus"
        :mode="'dark'"
        @click="suggestTool()"
      />
      <BaseButton
        :text="'Suggest Tools'"
        :icon="ScanBarcode"
        :mode="'dark'"
        @click="suggestTool()"
      />
    </div>
    <Handle
      type="target"
      position="top"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
    <NodeHeader :title="data.label" :hook="''" />
    <div
      style="
        width: 100%;
        height: 1px;
        margin: 10px 0;
        background-color: #dadada;
      "
    ></div>
    <p v-if="!this.selectedTool">Please select an option:</p>
    <div v-if="!this.selectedTool">
      <div
        v-for="solution in this.data.data.solution"
        :key="solution"
        class="toolOption flexSpaceBetweenRow"
      >
        <div
          class="clickableToolOption flexLeftRow"
          @click="selectTool(solution.data)"
        >
          <div v-if="solution.data.solution_logo" class="toolImg">
            <img :src="solution.data.solution_logo" height="20" width="20" />
          </div>
          <p>{{ solution.data.solution_name }}</p>
        </div>
        <div
          class="toolOptionBtn flexCenterRow"
          @click="openUrl(solution.data.solution_url)"
        >
          <CircleHelp size="15" color="#808080" />
          <div class="additionalText">{{ solution.data.solution_reason }}</div>
        </div>
      </div>
    </div>
    <p v-if="this.selectedTool">Selected option:</p>
    <div
      v-if="this.selectedTool != null"
      class="toolOption flexSpaceBetweenRow noHover"
    >
      <div class="clickableToolOption flexLeftRow">
        <div v-if="this.selectedTool.solution_logo" class="toolImg">
          <img :src="this.selectedTool.solution_logo" height="20" width="20" />
        </div>
        <p>{{ this.selectedTool.solution_name }}</p>
      </div>
      <div
        class="toolOptionBtn flexCenterRow"
        @click="openUrl(this.selectedTool.solution_url)"
      >
        <CircleHelp size="15" color="#808080" />
        <div class="additionalText">
          {{ this.selectedTool.solution_reason }}
        </div>
      </div>
    </div>
    <Handle
      type="source"
      position="bottom"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
  </div>
</template>

<script>
import { Handle } from "@vue-flow/core";
import BaseButton from "../buttons/BaseButton.vue";
import NodeHeader from "./NodeComponents/NodeHeader.vue";
import { ScanBarcode, ListPlus, CircleHelp } from "lucide-vue-next";

export default {
  name: "ToolNode",
  props: {
    selected: Boolean,
    data: Object,
    id: String,
    // title: String,
    // text: String,
  },
  components: {
    NodeHeader,
    Handle,
    BaseButton,
    CircleHelp,
  },
  methods: {
    toggleOptions() {
      this.toggledOptions = !this.toggledOptions;
    },
    selectTool(tool) {
      console.log(tool);
      this.selectedTool = tool;
    },
    openUrl(url) {
      if (url && !url.includes("https://") && !url.includes("http://"))
        url = "https://" + url;
      if (url) window.open(url, "_blank");
    },
    async suggestTool() {
      this.$emit("updateNodeTool", this.id, this.data);
    },
  },
  data() {
    return {
      toggledOptions: false,
      ScanBarcode,
      ListPlus,
      selectedTool: null,
      // PenTool,
    };
  },
};
</script>

<style scoped>
.nodeBox {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  background: white;
  width: 230px;
}
.nodeBox:hover {
  border: thin solid #721cff;
}
.nodeBox:active {
  box-shadow: 0 0 0 3px #ccadff;
}
.selectedBox {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.imgBox {
  height: 35px;
  width: 35px;
  background: #721cff10;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
#toolbar {
  position: absolute;
  background: #00000080;
  /* border: thin solid #721cff; */
  /* box-shadow: 0 0 0 3px #00000080; */
  transform: translate(-13px, -63px);
  padding: 6px;
  border-radius: 12px;
  display: flex;
  min-width: 225px;
}
.toolOption {
  border-radius: 7px;
  cursor: pointer;
  border: thin solid #dadada;
  margin-top: 5px;
}
.clickableToolOption {
  padding: 7px;
  width: 100%;
}
.toolOption:hover {
  border: thin solid #721cff;
  background: #efefef;
}
.toolImg {
  border-radius: 5px;
  overflow: hidden;
  height: 20px;
  width: 20px;
  margin-right: 10px;
}
.toolOptionBtn {
  padding: 4px;
  border-radius: 5px;
  cursor: help;
  margin-right: 7px;
}
.toolOptionBtn:hover {
  background: #dadada;
}
.additionalText {
  background: #000000aa;
  color: white;
  padding: 4px;
  border-radius: 5px;
  font-size: 12px;
  width: fit-content;
  position: absolute;
  transform: translateY(-100%);
  display: none;
}
.toolOptionBtn:hover .additionalText {
  display: block;
}
.noHover:hover {
  cursor: default;
  border: thin solid #808080;
}
</style>
